import type { ReactNode } from 'react';

interface ReportFooterProps {
  systemName?: string;
  note?:       string;
}

export const ReportFooter = ({
  systemName = 'myLedger ONE',
  note,
}: ReportFooterProps): ReactNode => (
  <div style={{
    borderTop: '1px solid #d1d5db',
    marginTop: '24px',
    paddingTop: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '9px',
    color: '#9ca3af',
  }}>
    <span>{systemName} — Confidential</span>
    {note && <span>{note}</span>}
    <span className="page-number">Page <span className="page" /> of <span className="pages" /></span>
  </div>
);
